import { render } from "./EventosComponent.vue?vue&type=template&id=edf09fc0&scoped=true"
import script from "./EventosComponent.vue?vue&type=script&lang=js"
export * from "./EventosComponent.vue?vue&type=script&lang=js"

import "./EventosComponent.vue?vue&type=style&index=0&id=edf09fc0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edf09fc0"]])

export default __exports__